import clsx from 'clsx';
import { forwardRef } from 'react';
import scrollbarStyles from '../../../../shared/styles/scrollbarThin.module.css';
import styles from './FiltersPanel.module.css';
import { FilterSection } from './components/FilterSection';
import { TagsSection } from './components/TagsSection';
import { TextActionButton } from '../../../../shared/ui/text-action';
import { useFiltersPanel } from './hooks/useFiltersPanel';

export const FiltersPanel = forwardRef(function FiltersPanel({ className = '', style }, ref) {
  const {
    filters,
    tags,
    tagsMode,
    setTagsMode,
    filterSections,
    tagsSearch,
    setTagsSearch,
    hasActiveFilters,
    toggleOption,
    resetFilters,
  } = useFiltersPanel();

  return (
    <aside ref={ref} className={clsx(styles.panel, className)} style={style} aria-label="Filters">
      <div className={styles.scrollArea}>
        <header className={clsx(styles.panelTitleBar)}>
          <div className={clsx(styles.header)}>
            <h2 className={clsx(styles.heading)}>Filters</h2>
            {hasActiveFilters && (
              <TextActionButton onClick={resetFilters} className={styles.resetButton}>
                Reset
              </TextActionButton>
            )}
          </div>
        </header>
        <div
          className={clsx(
            styles.scrollBody,
            scrollbarStyles.scrollbarThinY,
            scrollbarStyles.scrollbarGutterStable,
          )}
        >
          <TagsSection
            tags={tags}
            filters={filters}
            mode={tagsMode}
            onModeChange={setTagsMode}
            onToggle={toggleOption}
            searchValue={tagsSearch}
            onSearchChange={setTagsSearch}
          />

          {filterSections.map(({ sectionKey, title, items }) => (
            <FilterSection
              key={sectionKey}
              title={title}
              sectionKey={sectionKey}
              items={items}
              filters={filters}
              onToggle={toggleOption}
            />
          ))}
        </div>
      </div>
    </aside>
  );
});
